export const SET_AI_CONTENT = 'SET_AI_CONTENT'
export const SET_QUOTES = 'SET_QUOTES'
export const SET_DYNAMIC_TEXTS = 'SET_DYNAMIC_TEXTS'
export const SET_AI_SERVICES = 'SET_AI_SERVICES'
